import { render } from "./sidenav-item.vue?vue&type=template&id=18360e4f&scoped=true&ts=true"
import script from "./sidenav-item.vue?vue&type=script&lang=ts"
export * from "./sidenav-item.vue?vue&type=script&lang=ts"

import "./sidenav-item.vue?vue&type=style&index=0&id=18360e4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18360e4f"]])

export default __exports__